import { useModal } from '@/components/modal/useModal';
import { PriceHistoryModal } from '@/pages/product/price/PriceHistoryModal';
import { ProductDetailsModal } from '@/pages/product/product/ProductDetailsModal';
import { ProductMarginModal } from '@/pages/product/product/ProductMarginModal';
import { MarginType, Product } from '@/services/api/contracts/catalog/types';
import {
  AdminCatalogueConfiguration,
  CompanyCatalogueConfiguration,
  PartnerCatalogueConfiguration
} from '@/services/catalogue/catalogue';
import { useCatalogueService } from '@/services/catalogue/useCatalogueService';
import { FunctionComponent } from 'react';
import UnselectProductErrorModal from '../products/UnselectProductErrorModal';
import { ProductCard } from '../products/cards/ProductCard';
import { ProductCardOptions } from '../products/cards/ProductCardOptions';

interface CatalogueExplorerProductCardProps {
  product: Product;
}

const CatalogueExplorerProductCard: FunctionComponent<CatalogueExplorerProductCardProps> = ({ product }) => {
  const [configuration] = useCatalogueService(state => [state.configuration]);

  const priceHistoryModalProps = useModal<{
    productId: string;
  }>();
  const productDetailsModalProps = useModal<Product>();
  const productMarginModalProps = useModal<{
    initialValue: number;
    productId: string;
    configuration: CompanyCatalogueConfiguration | PartnerCatalogueConfiguration | AdminCatalogueConfiguration;
  }>();

  const getProductMarginValue = (product: Product): number => {
    const customerMargin = product.price?.margins?.find(
      margin => margin.party === 'Customer' && margin.marginType === MarginType.Item
    );
    return customerMargin ? customerMargin.margin : 0;
  };

  const unselectProductErrorModalProps = useModal<{ productId: string }>();

  return (
    <>
      <PriceHistoryModal {...priceHistoryModalProps} />
      <ProductDetailsModal {...productDetailsModalProps} />
      <ProductMarginModal {...productMarginModalProps} />
      <UnselectProductErrorModal {...unselectProductErrorModalProps} />
      <ProductCard product={product} priceHistoryModalProps={priceHistoryModalProps}>
        <ProductCardOptions
          product={product}
          openDetailsModal={() => productDetailsModalProps.open(product)}
          openMarginModal={() =>
            productMarginModalProps.open({
              initialValue: getProductMarginValue(product),
              productId: product.id,
              configuration: configuration
            })
          }
          openUnselectProductErrorModal={() =>
            unselectProductErrorModalProps.open({
              productId: product.id
            })
          }
        />
      </ProductCard>
    </>
  );
};

export default CatalogueExplorerProductCard;
